import {Component} from '@angular/core';
import {EditCustomerAddressComponent} from '../edit-customer-address/edit-customer-address.component';

@Component({
    selector: 'app-edit-customer-legacy-address',
    templateUrl: './edit-customer-legacy-address.component.html',
    standalone: false
})
export class EditCustomerLegacyAddressComponent extends EditCustomerAddressComponent {
}
